type Product = {
  id: number;
  name: string;
  costPrice: string | number;
  variants: Variant[];
};

type Variant = {
  cost_price: number;
  calculated_price: number;
};

type ProductsResponse = {
  productsSearch: Product[];
};

/**
 * @param data
 */
export const filterProductsByPrice = (data: ProductsResponse): ProductsResponse => {
  return {
    productsSearch: data.productsSearch.filter((product) => {

      // Check if all variants also have a zero price
      const allVariantsZero = product.variants.every(
        (variant) => variant.calculated_price === 0
      );

      return !allVariantsZero;
    }),
  };
}
